import store from '@admin/store';

const requirePermission = (to, from, next) => {
  const hasPermission = store.getters.xCheckUserPermission(
    'manage-program-owner'
  );

  if (hasPermission) {
    next();
  } else {
    next({ name: 'owner-program' });
  }
};

export default [
  {
    path: '/owner-program',
    name: 'owner-program',
    component: () =>
      import(
        /* webpackChunkName: "owner-program" */ '@admin/pages/OwnerProgram'
      ),
    meta: {
      auth: true,
    },
  },
  {
    path: '/owner-program/create',
    name: 'owner-program-create',
    component: () =>
      import(
        /* webpackChunkName: "owner-program-create" */ '@admin/pages/CreateOwnerProgram'
      ),
    meta: {
      auth: true,
    },
    beforeEnter: requirePermission,
  },
  {
    // Declared after `/owner-program/create` so the static path matches first.
    path: '/owner-program/:id',
    name: 'owner-program-detail',
    component: () =>
      import(
        /* webpackChunkName: "owner-program-detail" */ '@admin/pages/OwnerProgramDetail'
      ),
    meta: {
      auth: true,
    },
    beforeEnter: requirePermission,
  },
];
